module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp2_6005.13cdcdc7.png";